import $ from "jquery";

export function mobilemenu() {
	$(".js-menu").on("click", function() {
		$("body").toggleClass("menuopen");
		$("body").toggleClass("opensidemenu");
		$(".js-mobilemenu").toggleClass("open");
	});
	
	$(".js-watwijdoen").on("click", function(e) {
		e.stopPropagation();
		if ($("#subheader_watwijdoen").hasClass("show")) {
			$("#subheader_watwijdoen, .subheader").removeClass('show');
			$(this).removeClass('active');
		} else if ($("#subheader_wiewijzijn").hasClass("show")) {
			$(".onderdeel").removeClass('show');
			$("#subheader_watwijdoen").addClass('show');
			$('.js-wiewijzijn').removeClass('active');
			$(this).addClass('active');
		} else {
			$(".onderdeel, .subheader").removeClass('show');
			$("#subheader_watwijdoen, .subheader").addClass('show');
			$(this).addClass('active');
		}
	});
	
	$(".js-wiewijzijn").on("click", function(e) {
		e.stopPropagation();
		if ($("#subheader_wiewijzijn").hasClass("show")) {
			$("#subheader_wiewijzijn, .subheader").removeClass('show');
			$(this).removeClass('active');
		} else if ($("#subheader_watwijdoen").hasClass("show")) {
			$(".onderdeel").removeClass('show');
			$("#subheader_wiewijzijn").addClass('show');
			$('.js-watwijdoen').removeClass('active');
			$(this).addClass('active');
		} else {
			$(".onderdeel, .subheader").removeClass('show');
			$("#subheader_wiewijzijn, .subheader").addClass('show');
			$(this).addClass('active');
		}
	});

	$(document).on("click", function() {
		$(".onderdeel, .subheader").removeClass('show');
		$('.js-watwijdoen, .js-wiewijzijn').removeClass('active');
	});
	
	// Trigger closing the menu when clicking outside
	$("body").on("click", function() {
	  if ($("#mobile-menu").hasClass("show")) {
		$("#mobile-menu").removeClass("show").addClass("hide");
	  }
	});
	
	// Prevent clicks inside the menu from closing it
	$("#mobile-menu").on("click", function(e) {
	  e.stopPropagation();
	});
	
	// Opening the menu
	$(".js-menu").on("click", function(e) {
	  e.stopPropagation();
	  $("#mobile-menu").toggleClass("hide show");
	});
	

	// Klik events voor de hoofdmenu-items die een scherm openen
	$("#mobile-menu-diensten").on("click", function() {
		$("#mobile-menu-screen-diensten").removeClass("hide").addClass("show");
		$("#mobile-menu-main").removeClass("show");
	});
	
	// Klik events voor de hoofdmenu-items die een scherm openen
	$("#mobile-menu-onzewerkvelden").on("click", function() {
		$("#mobile-menu-screen-onzewerkvelden").removeClass("hide").addClass("show");
		$("#mobile-menu-main").removeClass("show")
	});
	
	// Klik events voor de hoofdmenu-items die een scherm openen
	$("#mobile-menu-onzemensen").on("click", function() {
		$("#mobile-menu-screen-onzemensen").removeClass("hide").addClass("show");
		$("#mobile-menu-main").removeClass("show")
	});
	
	// Klik events voor de hoofdmenu-items die een scherm openen
	$("#mobile-menu-organisatie").on("click", function() {
		$("#mobile-menu-screen-organisatie").removeClass("hide").addClass("show");
		$("#mobile-menu-main").removeClass("show")
	});

	// Klik events voor de 'Terug' knoppen
	$(".backbutton").on("click", function(e) {
		e.preventDefault();
		$(this).closest(".screen").removeClass("show").addClass("hide");
		$("#mobile-menu-main").removeClass("hide").addClass("show");
	});

}	